export default __webpack_public_path__ + "static/media/Background.bf40d251.png";